import { Component , OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OauthService } from './core/oauth.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  showSidebar: any;
  public currentUrl = '';
  public title = {};
  constructor(private _authService: OauthService, private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd ) {
        this.currentUrl = event.url;
      }
    });
   }
  ngOnInit(): void {
    if (this._authService.loggedIn()) {
      this.showSidebar = true;
    } else {
      this.showSidebar = false;
    }
  }

}
